import { render } from "./qk-tree-item.vue?vue&type=template&id=34e8b1da&scoped=true"
import script from "./qk-tree-item.vue?vue&type=script&lang=js"
export * from "./qk-tree-item.vue?vue&type=script&lang=js"

import "./qk-tree-item.vue?vue&type=style&index=0&id=34e8b1da&lang=scss&scoped=true"

import exportComponent from "D:\\project\\php\\quick_wucode\\quick_wucode\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34e8b1da"]])

export default __exports__